import {PipeTransform, Pipe, Injectable} from '@angular/core';
import {
  isDate,
  isNumber,
  isString,
  DateWrapper,
  isBlank,
} from '../facade/lang';
import {DateFormatter} from '../facade/intl';
import {StringMapWrapper} from '../facade/collection';

import {InvalidPipeArgumentException} from './invalid_pipe_argument_exception';


// TODO: move to a global configurable location along with other i18n components.
var defaultLocale: string = 'en-US';
export class DatePipe implements PipeTransform {
  /** @internal */
  static _ALIASES: {[key: string]: String} = {
    'medium': 'yMMMdjms',
    'short': 'yMdjm',
    'fullDate': 'yMMMMEEEEd',
    'longDate': 'yMMMMd',
    'mediumDate': 'yMMMd',
    'shortDate': 'yMd',
    'mediumTime': 'jms',
    'shortTime': 'jm'
  };


  transform(value: any, pattern: string = 'mediumDate'): string {
    if (isBlank(value)) return null;

    if (!this.supports(value)) {
      throw new InvalidPipeArgumentException(DatePipe, value);
    }

    if (isNumber(value)) {
      value = DateWrapper.fromMillis(value);
    } else if (isString(value)) {
      value = DateWrapper.fromISOString(value);
    }
    if (StringMapWrapper.contains(DatePipe._ALIASES, pattern)) {
      pattern = <string>StringMapWrapper.get(DatePipe._ALIASES, pattern);
    }
    return DateFormatter.format(value, defaultLocale, pattern);
  }

  private supports(obj: any): boolean {
    if (isDate(obj) || isNumber(obj)) {
      return true;
    }
    if (isString(obj) && isDate(DateWrapper.fromISOString(obj))) {
      return true;
    }
    return false;
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{name: 'date', pure: true}, ] },
{ type: Injectable },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
